// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductCreateContainer_wrapper__XqTKR","container1":"ProductCreateContainer_container1__1z2Ud"};